export const PERMISSIONS_FILTERS = {
  OWNED: 'can_write',
  SHARED: 'shared',
};
